// Shared by the Couriers add and update forms (Tracking Info, 2026-10-15).
// The server enforces the same rule; checking here just says it sooner.

// The tracking number is appended to this to make a link, so it has to be a
// web address -- the server refuses anything else (javascript:, ftp:, ...).
export const TRACKING_URL_RULE = /^https?:\/\/\S+$/i;

export const trackingUrlError = (value) => {
  const url = String(value ?? "").trim();
  if (!url) return null; // optional
  return TRACKING_URL_RULE.test(url)
    ? null
    : "Tracking URL must start with http:// or https://";
};

// Logos are shown on Tracking Info rows. SVG is refused by the server.
export const LOGO_TYPES = ["image/png", "image/jpeg", "image/webp", "image/gif"];
export const LOGO_ACCEPT = LOGO_TYPES.join(",");
export const logoTypeError = (file) =>
  file && !LOGO_TYPES.includes(file.type)
    ? "Logo must be a PNG, JPEG, WebP or GIF image"
    : null;

// The server's message, wherever it put it, else the transport error.
export const serverMessage = (err) =>
  err?.response?.data?.message?.message ||
  err?.response?.data?.message ||
  err?.message;
